/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  width: calc(500rem/14);
}
:host .dropArea {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
  padding: calc(5rem/14);
}
:host .dropArea > * {
  pointer-events: none;
}
:host .dropArea .container {
  position: relative;
  width: 100%;
  line-height: calc(100rem/14);
  height: calc(100rem/14);
}
:host .dropArea .container .svg,
:host .dropArea .container .border {
  width: 100%;
  height: calc(100rem/14);
}
:host .dropArea .container .border {
  fill: none;
  stroke-width: 2;
  stroke-dasharray: 12 10;
  stroke: #B4BEC5;
  stroke: var(--davinci-color-midgray-2, #B4BEC5);
}
:host .dropArea .container .description {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  font-weight: bold;
  color: #697987;
  color: var(--davinci-color-text-lighter, #697987);
}
:host .dropArea .container .description .icon {
  vertical-align: baseline;
  -webkit-transform: translateY(calc(7rem/14));
          transform: translateY(calc(7rem/14));
  margin-right: calc(5rem/14);
  fill: #B4BEC5;
  fill: var(--davinci-color-midgray-2, #B4BEC5);
}
:host .dropArea .container .description .labelBrowse {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host .selected {
  background-color: #F0F3F4;
  background-color: var(--davinci-color-lightgray-1, #F0F3F4);
}
:host .dropArea:hover {
  cursor: pointer;
}
:host .inputfile {
  position: absolute;
  top: calc(-5000rem/14);
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .dropArea > .container > .svg > .border {
  stroke: #B4BEC5;
  stroke: var(--davinci-color-midgray-2, #B4BEC5);
}
:host([disabled]) .dropArea > .container > .description {
  color: #8999A4;
  color: var(--davinci-color-midgray-1, #8999A4);
}
:host([disabled]) .dropArea > .container > .description .icon {
  fill: #D2D9DD;
  fill: var(--davinci-color-midgray-3, #D2D9DD);
}
:host([disabled]) .dropArea > .container > .description .labelBrowse {
  color: #8999A4;
  color: var(--davinci-color-midgray-1, #8999A4);
}`;
export { style };
//# sourceMappingURL=DnDFileChooser.style.js.map